export default __webpack_public_path__ + "static/media/fftx.1d513246.png";